import React from 'react'
import { Redirect } from 'react-router-dom'
import { isEmpty } from 'lodash'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import ProjectTypeCard from './ProjectTypeCard'
import ProjectTypeNotFound from './ProjectTypeNotFound'

import Resource from '../../stores/resource'
const ProjectTypeStore = Resource('project-types')

class ShowProjectTypePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      projectType: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    ProjectTypeStore.find(this.props.match.params.id)
      .then(result =>
        this.setState({
          projectType: result.data,
          loading: false
        })
      )
      .catch(error =>
        this.setState({
          projectType: {},
          error: errors.unpack(error),
          loading: false
        })
      )
  }

  _redirectTo = url => {
    this.setState({ redirect: url })
  }

  render() {
    const { loading, redirect, projectType } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect} />
    if (isEmpty(projectType)) return <ProjectTypeNotFound />

    return (
      <section>
        <header>
          <PageTitle>Project type</PageTitle>
        </header>
        <ProjectTypeCard
          projectType={projectType}
          editCallback={() =>
            this._redirectTo(`/project-types/${projectType.id}/edit`)
          }
          noHeightAdjust
        />
        <br />
        <BackButton />
      </section>
    )
  }
}

export default ShowProjectTypePage



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ShowProjectTypePage.jsx